import * as actions from '../constants/device_action_types.jsx';

const initialState = {
    devices: [],
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1}
    },
    loading: false,
    errors: {},
    forceReload: false
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
    case actions.START_REQUEST:
    {
        return {
            ...state,
            loading: true
        };
            }
    case actions.END_REQUEST:
    {
        return {
            ...state,
            loading: false
        };
    }
    case actions.GET_DEVICES:
    {
        return {
            ...state,
            devices: action.devices.items,
            filter: action.devices.filter,
            loading: false,
            errors: {},
            forceReload: false
        };
    }
    case actions.ADD_DEVICE:
    {
        return {
            ...state,
            devices: [ ...state.devices, action.device ],
            forceReload: true
        };
    }
    case actions.EDIT_DEVICE:
    {
        return {
            ...state,
            devices: state.devices.map((item, index) => {
                if (item.deviceId !== action.device.deviceId) {
                    // This isn't the item we care about - keep it as-is
                    return item;
                }

                // Otherwise, this is the one we want - return an updated value
                return {
                    ...item,
                    ...action.item
                };
            }),
            forceReload: true
        };
    }
    default:
        return state;
    }
};